/* global JurisdictionsHelper */

import React, { Component } from 'react';

import Landing from './Pages/Landing';
import AuthoringStatus from './Pages/AuthoringStatus';
import ConditionDetails from './Pages/ConditionDetails';

import { UserContextProvider } from './Context/User';
import { DataContextProvider } from './Context/Data';
import MTSClient from './Data/mts-rs-client';
import ReportsService from './Data/reports-service';
import buildAdminReport from './Pages/AdminReports';
import serveCSV from './Pages/AdminReports/serveCSV';
import serveXLSX from './Pages/AdminReports/serveXLSX';

import Spinner from './Components/Spinner';
import ReportTypeModal from './Components/Modals/ReportTypeModal';

const { FEATURE_REPORTS_NAVBAR_UI } = process.env;

const LOADING_TYPES = {
    GENERATING_REPORT: 'Generating Admin Report...',
    FETCHING_LATEST_REPORT: 'Fetching last generated Admin Report...',
    FETCHING_LATEST_REPORT_DATA: 'Fetching metadata for last generated Report...',
    DOWNLOADING_REPORT: 'Downloading Report...'
};

const transformStatus = (str) => {
    return str
        .split('_')
        .map((v) => {
            v = v.toLowerCase();
            return v.charAt(0).toUpperCase() + v.slice(1);
        })
        .join(' ');
};

class App extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleReportPathSelect = this.handleReportPathSelect.bind(this);
        this.fetchRender = this.fetchRender.bind(this);
        this.updateDataForJurisdictionId = this.updateDataForJurisdictionId.bind(this);
        this.fetchReportData = this.fetchReportData.bind(this);
        this.updateDataForUserContext = this.updateDataForUserContext.bind(this);
        this.modalRef = React.createRef();

        this.pages = {
            0: 'landing',
            1: 'authoring-status',
            2: 'condition-details'
        };

        this.state = {
            page: 0,
            userState: {
                role: null,
                jurisdictionId: null,
                sessionToken: null
            },
            dataContext: {
                jurisdiction: {},
                condition: {}
            },
            loading: null
        };
    }

    componentDidMount() {
        this.harvestSessionData();
    }

    updateDataForJurisdictionId(id = false) {
        if (id) {
            if (id === 'default') {
                MTSClient(this.state.userState.sessionToken)
                    .fromDefault()
                    .fetchConditions()
                    .then((conditions) => {
                        conditions = conditions.reduce((options, v) => {
                            if (typeof v.version === 'string') {
                                options[v.conditionId] = `${v.name} | ${v.version}`;
                            } else {
                                options[v.conditionId] = `${v.name}`;
                            }
                            if (v.status) {
                                options[v.conditionId] = `${options[v.conditionId]} - ${transformStatus(v.status)}`;
                            }
                            return options;
                        }, {});
                        this.setState({
                            dataContext: {
                                ...this.state.dataContext,
                                condition: conditions
                            }
                        });
                    })
                    .catch((err) => {
                        alert(err);
                    });
            } else {
                MTSClient(this.state.userState.sessionToken)
                    .fromJurisdiction(id)
                    .fetchConditions()
                    .then((conditions) => {
                        conditions = conditions.reduce((options, v) => {
                            v = v.conditionDTO;
                            if (typeof v.version === 'string') {
                                options[v.conditionId] = `${v.name} | ${v.version}`;
                            } else {
                                options[v.conditionId] = `${v.name}`;
                            }
                            if (v.status) {
                                options[v.conditionId] = `${options[v.conditionId]} - ${transformStatus(v.status)}`;
                            }
                            return options;
                        }, {});
                        this.setState({
                            dataContext: {
                                ...this.state.dataContext,
                                condition: conditions
                            }
                        });
                    })
                    .catch((err) => {
                        alert(err);
                    });
            }
        }
    }

    harvestSessionData() {
        // For now just grab a session token
        // let jurisdictionAdmin = {
        //     role: 'JURISDICTION_ADMIN',
        //     jurisdictionId: '4907b550652e0849b483582cebaf1850'
        // };
        //
        // let rckmsAdmin = {
        //     role: 'RCKMS_ADMIN',
        //     jurisdictionId: null
        // };
        let userDTO = JSON.parse(sessionStorage.getItem('rckmsUserDTO'));
        let sessionToken = sessionStorage.getItem('sessionId');
        let { role, jurisdictionId, ...rest } = userDTO;

        let userContext = {
            role,
            jurisdictionId: typeof jurisdictionId !== 'undefined' ? jurisdictionId : null,
            sessionToken
        };

        if (sessionToken) {
            this.setState({ userState: { ...this.state.userState, ...userContext } }, () => {
                this.updateDataForUserContext();
            });
        }
    }

    updateDataForUserContext() {
        MTSClient(this.state.userState.sessionToken)
            .fetchAllJurisdictions()
            .then((allJurisdictions) => {
                const isAdmin =
                    typeof this.state.userState === 'object' && this.state.userState?.role === 'RCKMS_ADMINISTRATOR';
                let jurisdictionOptions = (!isAdmin
                    ? JurisdictionsHelper.filterTestJurisdictions(allJurisdictions)
                    : allJurisdictions
                ).reduce((options, v) => {
                    options[v.jurisdictionId] = v.name;
                    return options;
                }, {});
                jurisdictionOptions = {
                    default: 'Default',
                    ...jurisdictionOptions
                };
                this.setState({
                    dataContext: {
                        ...this.state.dataContext,
                        ...{ jurisdiction: jurisdictionOptions }
                    }
                });
            })
            .catch((err) => {
                console.log(3);
                alert(err);
            });
    }

    fetchSingleBatch(batch, type = 'vs') {
        if (type === 'vs') {
            return new Promise((resolve, reject) => {
                Promise.all(
                    batch.map((v) => {
                        return MTSClient(this.state.userState.sessionToken)
                            .fromCondition(v)
                            .fetchConceptsByCondition();
                    })
                )
                    .then((responses) => {
                        resolve(responses);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else if (type === 'cc') {
            return new Promise((resolve, reject) => {
                Promise.all(
                    batch.map((v) => {
                        return Promise.all([
                            MTSClient(this.state.userState.sessionToken)
                                .fromCondition(v)
                                .fetchCriteriaRels(),
                            MTSClient(this.state.userState.sessionToken)
                                .fromCondition(v)
                                .fetch()
                        ]);
                    })
                )
                    .then((responses) => {
                        resolve(responses);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else if (type === 'as') {
            return new Promise((resolve, reject) => {
                Promise.all(
                    batch.map((v) => {
                        return MTSClient(this.state.userState.sessionToken)
                            .fromCondition(v.conditionDTO.conditionId)
                            .fetchLinksAndReferences();
                    })
                )
                    .then((responses) => {
                        resolve(responses);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        } else {
            return Promise.reject('Unsupported Report');
        }
    }

    fetchBatchedAdminReportsData = async (type = 'vs') => {
        return new Promise((resolve, reject) => {
            MTSClient(this.state.userState.sessionToken)
                .fromDefault()
                .fetchConditions()
                .then(async (conditions) => {
                    let batchIndex = 0;
                    let batchedConditions = conditions.reduce((batched, v, i) => {
                        if (typeof batched[batchIndex] && Array.isArray(batched[batchIndex])) {
                            batched[batchIndex].push(v.conditionId);
                        } else {
                            batched[batchIndex] = [v.conditionId];
                        }
                        if (i % 2 === 1) {
                            batchIndex++;
                        }
                        return batched;
                    }, []);
                    let responses = [],
                        processedBatches = 0,
                        tmp = null,
                        nextBatch;
                    let batchCount = batchedConditions.length;
                    while (batchedConditions.length > 0) {
                        nextBatch = batchedConditions.shift();
                        try {
                            tmp = await this.fetchSingleBatch(nextBatch, type);
                            responses.push(...tmp);
                            processedBatches += 1;
                            this.setState({ progress: Math.floor(100 * (processedBatches / batchCount)) });
                        } catch (e) {
                            console.log(e);
                            reject(e);
                        }
                    }
                    let resultMap = conditions.reduce((agg, v, i) => {
                        agg[v.conditionId] = responses[i];
                        return agg;
                    }, {});
                    resolve(resultMap);
                })
                .catch((e) => {
                    console.log(e);
                    reject(e);
                });
        });
    };

    fetchBatchedAuthoringStatus = async (reportContext) => {
        return new Promise((resolve, reject) => {
            Promise.all([
                MTSClient(this.state.userState.sessionToken)
                    .fromJurisdiction(reportContext.jurisdiction.value)
                    .fetch(),
                MTSClient(this.state.userState.sessionToken)
                    .fromJurisdiction(reportContext.jurisdiction.value)
                    .fetchConditions(),
                MTSClient(this.state.userState.sessionToken)
                    .fromJurisdiction(reportContext.jurisdiction.value)
                    .fetchContacts(),
                MTSClient(this.state.userState.sessionToken)
                    .fromJurisdiction(reportContext.jurisdiction.value)
                    .fetchZipCodes(),
                MTSClient(this.state.userState.sessionToken)
                    .fromJurisdiction(reportContext.jurisdiction.value)
                    .fetchUsers()
            ])
                .then(async (responses) => {
                    let conditions = responses[1];
                    let batchIndex = 0;
                    let batchedConditions = conditions.reduce((batched, v, i) => {
                        if (typeof batched[batchIndex] && Array.isArray(batched[batchIndex])) {
                            batched[batchIndex].push(v);
                        } else {
                            batched[batchIndex] = [v];
                        }
                        if (i % 2 === 1) {
                            batchIndex++;
                        }
                        return batched;
                    }, []);
                    let references = [],
                        processedBatches = 0,
                        tmp = null,
                        nextBatch;
                    let batchCount = batchedConditions.length;
                    while (batchedConditions.length > 0) {
                        nextBatch = batchedConditions.shift();
                        try {
                            tmp = await this.fetchSingleBatch(nextBatch, 'as');
                            references.push(...tmp);
                            processedBatches += 1;
                            this.setState({ progress: Math.floor(100 * (processedBatches / batchCount)) });
                        } catch (e) {
                            console.log(e);
                            reject(e);
                        }
                    }
                    resolve({
                        jurisdiction: responses[0],
                        conditions,
                        contacts: responses[2],
                        zipCodes: responses[3],
                        users: responses[4],
                        externalReferences: references.filter((v) => v.length > 0)
                    });
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                });
        });
    };

    fetchAuthoringStatusData() {
        return ReportsService.fetchAuthoringStatusData();
    }

    createLoadingState(loadingMessage) {
        return {
            isLoading: true,
            title: loadingMessage
        };
    }

    handleReportPathSelect(val, reportContext) {
        switch (val) {
            case 'authoring-status':
                this.setState({ page: 1 });
                /*
                window.dataLayer.push({
                    event: 'reports_selectReportPath',
                    rckmsEventCategory: `Reports`,
                    rckmsEventAction: `Select Type`,
                    rckmsEventLabel: `Authoring Status`
                });
                */
                break;
            case 'authoring-status-excel':
                if (!this.state.loading) {
                    this.setState(
                        {
                            loading: this.createLoadingState(LOADING_TYPES.DOWNLOADING_REPORT)
                        },
                        () => {
                            this.fetchReportData('authoringStatusXlsx', reportContext)
                                .then(({ headers, data }) => {
                                    const fileName = headers['report-filename'];

                                    serveXLSX(data, fileName);
                                })
                                .catch((e) => {
                                    alert(e);
                                })
                                .finally(() => {
                                    this.setState({
                                        loading: null,
                                        progress: null
                                    });
                                });
                        }
                    );
                }
                break;
            case 'condition-details':
                this.setState({ page: 2 });
                /*
                window.dataLayer.push({
                    event: 'reports_selectReportPath',
                    rckmsEventCategory: `Reports`,
                    rckmsEventAction: `Select Type`,
                    rckmsEventLabel: `Condition Details`
                });
                */
                break;
            case 'condition-details-excel':
                if (!this.state.loading) {
                    this.setState(
                        {
                            loading: this.createLoadingState(LOADING_TYPES.DOWNLOADING_REPORT)
                        },
                        () => {
                            this.fetchReportData('conditionDetailsXlsx', reportContext)
                                .then(({ headers, data }) => {
                                    const fileName = headers['report-filename'];

                                    serveXLSX(data, fileName, false);
                                })
                                .catch((e) => {
                                    alert(e);
                                })
                                .finally(() => {
                                    this.setState({
                                        loading: null,
                                        progress: null
                                    });
                                });
                        }
                    );
                }
                break;
            case 'all-value-sets-concepts':
                if (!this.state.loading) {
                    if (
                        process.env.FEATURE_REPORTS_ENABLE_NEW_ALL_VALUE_SETS &&
                        process.env.FEATURE_REPORTS_ENABLE_NEW_ALL_VALUE_SETS !== 'false'
                    ) {
                        this.setState(
                            {
                                loading: this.createLoadingState(LOADING_TYPES.FETCHING_LATEST_REPORT_DATA)
                            },
                            () => {
                                ReportsService(this.state.userState.sessionToken)
                                    .fetchLatestAllConceptsValueSetsMetadata()
                                    .then((metaData) => {
                                        this.setState({ loading: null });
                                        this.modalRef.current.openModal({
                                            ...metaData,
                                            title: 'All Value Sets & Concepts Export',
                                            actions: {
                                                generateReport: () =>
                                                    new Promise((resolve, reject) => {
                                                        this.setState(
                                                            {
                                                                loading: this.createLoadingState(
                                                                    LOADING_TYPES.GENERATING_REPORT
                                                                ),
                                                                progress: 0
                                                            },
                                                            () => {
                                                                this.fetchReportData('all-value-sets-concepts--new')
                                                                    .then((data) => {
                                                                        resolve(data);
                                                                    })
                                                                    .catch((e) => {
                                                                        alert(e);
                                                                        reject(e);
                                                                    })
                                                                    .finally(() => {
                                                                        this.setState({
                                                                            loading: null,
                                                                            progress: null
                                                                        });
                                                                    });
                                                            }
                                                        );
                                                    }),
                                                downloadLatest: (reportRef) => {
                                                    this.setState(
                                                        {
                                                            loading: this.createLoadingState(
                                                                LOADING_TYPES.FETCHING_LATEST_REPORT
                                                            ),
                                                            progress: 0
                                                        },
                                                        () => {
                                                            this.fetchReportData('all-value-sets-concepts', {
                                                                reportRef
                                                            })
                                                                .then((data) => {
                                                                    const { fileName, payload } = data;

                                                                    serveCSV(payload, fileName);
                                                                })
                                                                .catch((e) => {
                                                                    alert(e);
                                                                })
                                                                .finally(() => {
                                                                    this.setState({
                                                                        loading: null,
                                                                        progress: null
                                                                    });
                                                                });
                                                        }
                                                    );
                                                }
                                            }
                                        });
                                    });
                            }
                        );
                    } else {
                        this.setState(
                            {
                                loading: this.createLoadingState(LOADING_TYPES.GENERATING_REPORT),
                                progress: 0
                            },
                            () => {
                                this.fetchReportData('all-value-sets-concepts')
                                    .then((data) => {
                                        buildAdminReport(data, 'all-value-sets-concepts');
                                    })
                                    .catch((e) => {
                                        alert(e);
                                    })
                                    .finally(() => {
                                        this.setState({
                                            loading: null,
                                            progress: null
                                        });
                                    });
                            }
                        );
                    }
                }
                break;
            case 'all-condition-criteria':
                if (!this.state.loading) {
                    this.setState(
                        {
                            loading: this.createLoadingState(LOADING_TYPES.GENERATING_REPORT),
                            progress: 0
                        },
                        () => {
                            this.fetchReportData('all-condition-criteria')
                                .then((specMap) => {
                                    buildAdminReport(specMap, 'all-condition-criteria');
                                    this.setState({
                                        loading: null,
                                        progress: null
                                    });
                                })
                                .catch((e) => {
                                    alert(e);
                                });
                        }
                    );
                }
                break;
            case 'all-conditions':
                if (!this.state.loading) {
                    this.setState(
                        {
                            loading: this.createLoadingState(LOADING_TYPES.GENERATING_REPORT)
                        },
                        () => {
                            this.fetchReportData('all-conditions')
                                .then(({ fileName, payload }) => {
                                    serveCSV(payload, fileName);
                                })
                                .catch((e) => {
                                    alert(e);
                                })
                                .finally(() => {
                                    this.setState({
                                        loading: null,
                                        progress: null
                                    });
                                });
                        }
                    );
                }
                break;
            case 'all-jurisdiction-status':
                if (!this.state.loading) {
                    this.setState(
                        {
                            loading: this.createLoadingState(LOADING_TYPES.GENERATING_REPORT)
                        },
                        () => {
                            this.fetchReportData('all-jurisdiction-status')
                                .then(({ fileName, payload }) => {
                                    serveCSV(payload, fileName);
                                })
                                .catch((e) => {
                                    alert(e);
                                })
                                .finally(() => {
                                    this.setState({
                                        loading: null,
                                        progress: null
                                    });
                                });
                        }
                    );
                }
                break;

            case 'all-user-accounts':
                if (!this.state.loading) {
                    this.setState(
                        {
                            loading: this.createLoadingState(LOADING_TYPES.GENERATING_REPORT)
                        },
                        () => {
                            this.fetchReportData('all-user-accounts')
                                .then((users) => {
                                    buildAdminReport(users, 'all-user-accounts');
                                    this.setState({
                                        loading: null
                                    });
                                })
                                .catch((e) => {
                                    alert(e);
                                });
                        }
                    );
                }
                break;

            case 'home':
                this.setState({ page: 0 });
                break;
            default:
                console.log('invalid path set');
        }
    }

    fetchReportData(type, reportContext) {
        switch (type) {
            case 'authoringStatus':
                // return this.fetchBatchedAuthoringStatus(reportContext);
                return ReportsService(this.state.userState.sessionToken).fetchAuthoringStatusData(
                    reportContext.jurisdiction.value
                );
            case 'authoringStatusXlsx':
                return ReportsService(this.state.userState.sessionToken).fetchAuthoringStatusXlsxReport(
                    reportContext.jurisdiction.value
                );
            case 'conditionDetailsXlsx':
                // What happens if jurisdiction is 'default'
                return ReportsService(this.state.userState.sessionToken).fetchConditionDetailsXlsxReport(
                    reportContext.condition.value
                );
            case 'conditionDetails':
                // return new Promise((resolve, reject) => {
                //     Promise.all([
                //         reportContext.jurisdiction.value === 'default'
                //             ? Promise.resolve(JSON.stringify({}))
                //             : MTSClient(this.state.userState.sessionToken)
                //                 .fromJurisdiction(reportContext.jurisdiction.value)
                //                 .fetch(),
                //         MTSClient(this.state.userState.sessionToken)
                //             .fromCondition(reportContext.condition.value)
                //             .fetch(),
                //         MTSClient(this.state.userState.sessionToken)
                //             .fromCondition(reportContext.condition.value)
                //             .fetchSpecifications(),
                //         MTSClient(this.state.userState.sessionToken)
                //             .fromCondition(reportContext.condition.value)
                //             .fetchCriteriaRels(),
                //         MTSClient(this.state.userState.sessionToken)
                //             .fromCondition(reportContext.condition.value)
                //             .fetchLogicSets(),
                //         MTSClient(this.state.userState.sessionToken)
                //             .fromCondition(reportContext.condition.value)
                //             .fetchConceptsByCondition(),
                //         MTSClient(this.state.userState.sessionToken)
                //             .fromCondition(reportContext.condition.value)
                //             .fetchLinksAndReferences('BOTH')
                //         // MTSClient(this.state.userState.sessionToken).fromJurisdiction(reportContext.jurisdiction.value).fetchContacts(),
                //         // MTSClient(this.state.userState.sessionToken).fromJurisdiction(reportContext.jurisdiction.value).fetchZipCodes()
                //     ])
                //         .then((responses) => {
                //             console.log(responses);
                //             resolve({
                //                 jurisdiction: responses[0],
                //                 condition: responses[1],
                //                 specifications: responses[2],
                //                 criteriaRels: responses[3],
                //                 logicSets: responses[4],
                //                 concepts: responses[5],
                //                 references: responses[6]
                //             });
                //         })
                //         .catch((err) => {
                //             console.log(err);
                //             reject(err);
                //         });
                // });

                return ReportsService(this.state.userState.sessionToken).fetchConditionDetailsData(
                    reportContext.condition.value
                );
            case 'all-value-sets-concepts':
                return process.env.FEATURE_REPORTS_ENABLE_NEW_ALL_VALUE_SETS &&
                    process.env.FEATURE_REPORTS_ENABLE_NEW_ALL_VALUE_SETS !== 'false'
                    ? ReportsService(this.state.userState.sessionToken).fetchAllConceptsValueSetsReport(
                          reportContext.reportRef
                      )
                    : this.fetchBatchedAdminReportsData('vs');
            case 'all-value-sets-concepts--new':
                return ReportsService(this.state.userState.sessionToken).generateNewConceptsValueSetsReport();
            case 'all-condition-criteria':
                return this.fetchBatchedAdminReportsData('cc');
            case 'all-jurisdiction-status':
                return ReportsService(this.state.userState.sessionToken).fetchAllJurisdictionStatusReport();
            case 'all-conditions':
                return ReportsService(this.state.userState.sessionToken).fetchAllConditionReport();

            case 'all-user-accounts':
                return new Promise((resolve, reject) => {
                    MTSClient(this.state.userState.sessionToken)
                        .fromDefault()
                        .fetchUserAccounts()
                        .then((users) => {
                            resolve(users);
                        })
                        .catch((e) => {
                            console.log(e);
                            reject(e);
                        });
                });

            default:
                return Promise.reject(new Error('invalid report'));
        }
    }

    fetchRender() {
        switch (this.state.page) {
            case 0:
                return (
                    <Landing handleReportPathSelect={this.handleReportPathSelect} userContext={this.state.userState} />
                );
            case 1:
                return (
                    <AuthoringStatus
                        userContext={this.state.userState}
                        dataContext={this.state.dataContext}
                        fetchReportData={this.fetchReportData}
                        back={() => this.handleReportPathSelect('home')}
                        handleReportPathSelect={this.handleReportPathSelect}
                    />
                );
            case 2:
                return (
                    <ConditionDetails
                        userContext={this.state.userState}
                        dataContext={this.state.dataContext}
                        fetchReportData={this.fetchReportData}
                        updateDataForJurisdictionId={this.updateDataForJurisdictionId}
                        back={() => this.handleReportPathSelect('home')}
                        handleReportPathSelect={this.handleReportPathSelect}
                    />
                );
            default:
                return <Landing handleReportPathSelect={this.handleReportPathSelect} />;
        }
    }

    render() {
        return (
            <>
                <div
                    className={`layout-container ${
                        FEATURE_REPORTS_NAVBAR_UI !== 'true' ? 'layout-container--legacy' : ''
                    }`}
                >
                    <UserContextProvider value={this.state.userState}>
                        <DataContextProvider value={this.state.dataContext}>{this.fetchRender()}</DataContextProvider>
                    </UserContextProvider>
                    {this.state.loading && this.state.loading.isLoading && (
                        <div className="loading-admin-report">
                            <Spinner size={`1.42rem`} />
                            <div className="h3">{this.state.loading.title}</div>
                            {typeof this.state.progress == 'number' && <div className="h3">{this.state.progress}%</div>}
                        </div>
                    )}
                </div>
                <ReportTypeModal ref={this.modalRef} />
            </>
        );
    }
}

export default App;
